import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateApplicationRequirementsApi = createApi({
  reducerPath: 'policyTemplateApplicationRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getApplicationRequirementsPreview: builder.query({
      query: ({ templateId, customerId, includeApplicationIds, excludeApplicationIds }) => ({
        url: `/secure/policy/template/${templateId}/application-requirements/preview`,
        params: {
          customerId,
          // The deploy's current application ids, so the preview checks what will be sent rather
          // than what the template saved (a prompted field can replace them).
          ...(includeApplicationIds && excludeApplicationIds
            ? {
                includeApplicationIds: includeApplicationIds.join(','),
                excludeApplicationIds: excludeApplicationIds.join(','),
              }
            : {}),
        },
      }),
    }),
  }),
})

export const { useGetApplicationRequirementsPreviewQuery, useLazyGetApplicationRequirementsPreviewQuery } =
  policyTemplateApplicationRequirementsApi

export const useApplicationRequirementsPreview = (
  { templateId, customerId: customerIdOverride, includeApplicationIds, excludeApplicationIds },
  options = {},
) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  // Deploy from a check can target a different tenant than the globally selected customer.
  // Callers pass that tenant; otherwise fall back to the global selection.
  const customerId = customerIdOverride ?? selectedCustomerId

  return useGetApplicationRequirementsPreviewQuery(
    { templateId, customerId, includeApplicationIds, excludeApplicationIds },
    { ...options, skip: options.skip || !templateId || !customerId },
  )
}
